import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, tap } from 'rxjs/operators';
import { CustomerTankModel } from "src/app/models/customer/customerDashboard.model";
import { SaveTankResponse, TankListResponseModel, TankModel } from "src/app/models/tank/tank.model";
import { TankAlertModel } from "src/app/models/tank/tankAlert.model";
import { TankDeliveryModel, TankDeliveryResponse } from "src/app/models/tank/tankDelivery.model";
import { PagedResponse, TankGridModel, TankGridModel2, TankPagedRequest } from "src/app/models/tank/tankGrid.model";
import { TankReadingModel } from "src/app/models/tank/tankReading.model";
import { TankStatusCode } from "src/app/models/tank/tankStatusCode.model";
import { TankViewerModel } from "src/app/models/tank/tankViewer";

@Injectable({
    providedIn: 'root'
})
export class TanksDataService {

    private TANKSDATA_URL = 'api/tanksData'
    private TANKDATA_URL = 'api/tanksData/'
    private TANK_FILTERED_URL = 'api/tanksData/filteredData/'
    private TANK_TEMPCOMP_URL = 'api/tanksData/temp-comp/'
    private TANK_URL = 'api/tanksData/tank/'
    private TANK_SAVE_URL = 'api/tanksData/saveTank'
    private TANK_ALERTS_URL = 'api/tanksData/getTankAlerts/'
    private TANK_READING_URL = 'api/tanksData/getTankReadings/'
    private TANK_READING_BY_DATES_URL = 'api/tanksData/getTankReadingsByDateRange/'
    private TANK_READING_BY_MONTH_URL = 'api/tanksData/getTankReadingsByMonth/'
    private TANK_STATUS_CODES_URL = 'api/tanksData/tankStatusCode'
    private TANK_SAVE_ALERTS_URL = 'api/tanksData/saveTankAlerts'
    private TANK_SAVE_LIST_URL = 'api/tanksData/saveTankList'
    private TANK_SAVE_CUST_LIST_URL = 'api/tanksData/saveTankCustList'
    private TANK_REMOVE_CUST_LIST_URL = 'api/tanksData/saveRemoveTankCustList'
    private TANK_LIST_URL = 'api/tanksData/getTankList/'
    private TANK_VIEWERS_URL = 'api/tanksData/getTankViewers/'
    private TANK_DELIVERIES_URL = 'api/tanksData/getDeliveries/'


    constructor(
        private _httpClient: HttpClient
    ) {
    }

   
    get getTanksData$(): Observable<TankModel[]> {
        return this._httpClient.get<TankModel[]>(this.TANKSDATA_URL);
    }

    getTankDetails$(id: string): Observable<TankGridModel[]> {
        return this._httpClient.get<TankGridModel[]>(`${this.TANKDATA_URL}${id}`);
      }

    getFilteredTankDetails$(id: string): Observable<TankGridModel[]> {
        return this._httpClient.get<TankGridModel[]>(`${this.TANK_FILTERED_URL}${id}`);
      }

  getTempCompTankDetails$(distributorId: string): Observable<TankGridModel[]> {
    return this._httpClient.get<TankGridModel[]>(`${this.TANK_TEMPCOMP_URL}${distributorId}`);
  }

  getTankDetailsPaged$(req: TankPagedRequest): Observable<PagedResponse<TankGridModel>> {
  return this._httpClient.post<PagedResponse<TankGridModel>>(
    `${this.TANKDATA_URL}paged`, req
  );
}

getFilteredTankDetailsPaged$(req: TankPagedRequest): Observable<PagedResponse<TankGridModel>> {
  return this._httpClient.post<PagedResponse<TankGridModel>>(
    `${this.TANKDATA_URL}filteredData/paged`, req
  );
}

getTempCompTankDetailsPaged$(req: TankPagedRequest): Observable<PagedResponse<TankGridModel>> {
  return this._httpClient.post<PagedResponse<TankGridModel>>(
    `${this.TANKDATA_URL}temp-comp/paged`, req
  );
}


  // getTankDetails2$(id: string): Observable<TankGridModel2[]> {
  //   return this._httpClient.get<TankGridModel2[]>(`${this.TANKDATA_URL}${id}`);
  // }

    getTank$(id: number): Observable<TankModel> {
        let tank = this._httpClient.get<TankModel>(`${this.TANK_URL}${id}`);
        return tank;
    }

    getTankAlert$(id: number): Observable<TankAlertModel[]> {
        let tankAlerts = this._httpClient.get<TankAlertModel[]>(`${this.TANK_ALERTS_URL}${id}`);
        return tankAlerts;
    }

    getTankReadings$(id: number): Observable<TankReadingModel> {
      let tankReading = this._httpClient.get<TankReadingModel>(`${this.TANK_READING_URL}${id}`);
      return tankReading;
    }

    getTankReadingsByMonth$(id: number, months: number): Observable<TankReadingModel> {
      let tankReading = this._httpClient.get<TankReadingModel>(`${this.TANK_READING_BY_MONTH_URL}${id}/${months}`);
      return tankReading;
    }

    getTankReadingsByDateRange$(id: number, startDate: string, endDate: string): Observable<TankReadingModel> {
      let tankReading = this._httpClient.get<TankReadingModel>(`${this.TANK_READING_BY_DATES_URL}${id}/${startDate}/${endDate}`);
      return tankReading;
    }

    get getTankStatusCodes$(): Observable<TankStatusCode[]>{
      return this._httpClient.get<TankStatusCode[]>(this.TANK_STATUS_CODES_URL);
    }

    getTankListById$(id: string): Observable<TankListResponseModel[]> {
      return this._httpClient.get<TankListResponseModel[]>(`${this.TANK_LIST_URL}${id}`);
    }

    getTankViewers$(id: number): Observable<TankViewerModel[]> {
      return this._httpClient.get<TankViewerModel[]>(`${this.TANK_VIEWERS_URL}${id}`);
    }

    getDeliveries$(id: number): Observable<TankDeliveryResponse> {
      return this._httpClient.get<TankDeliveryResponse>(`${this.TANK_DELIVERIES_URL}${id}`);
    }

  acknowledgeFailedRequest$(requestId: number): Observable<void> {
    return this._httpClient.post<void>(`/api/tanksData/acknowledgeFailedRequest`, requestId);
  }


  /* editTank$(tankModel: TankModel): Observable<TankModel | null> {
    return this._httpClient.post<TankModel>(this.TANK_EDIT_URL, tankModel).pipe(
      tap(response => {
      }),
      catchError(error => {
        console.log(error);
        return of(null);
      }),
    );
  } */

  saveTank$(tankModel: TankModel, isEdit: boolean): Observable<SaveTankResponse | null> {
    return this._httpClient.post<SaveTankResponse>(
      this.TANK_SAVE_URL,
      { TankModel: tankModel, IsEdit: isEdit }
    ).pipe(
      catchError(error => {
        console.log(error);
        return of(null);
      }),
    );
  }

    saveTankAlerts$(id: number, tankAlerts: TankAlertModel[]): Observable<TankAlertModel[] | null> {
      return this._httpClient.post<TankAlertModel[]>(this.TANK_SAVE_ALERTS_URL, { TankId: id, TankAlerts: tankAlerts }).pipe(
        tap(response => {
  
        }),
        catchError(error => {
          console.log(error);
          return of(null);
        }),
      );
    }

  saveTankLists$(id: number, tankIds: number[]): Observable<CustomerTankModel[] | null> {
    return this._httpClient.post<CustomerTankModel[]>(this.TANK_SAVE_LIST_URL, { CustomerId: id, TankIds: tankIds }).pipe(
      tap(response => {

      }),
      catchError(error => {
        console.log(error);
        return of(null);
      }),
    );
  }

  saveCustTankList$(id: number, custIds: number[]): Observable<number[] | null> {
    return this._httpClient.post<number[]>(this.TANK_SAVE_CUST_LIST_URL, { TankId: id, CustomerIds: custIds }).pipe(
      tap(response => {

      }),
      catchError(error => {
        console.log(error);
        return of(null);
      }),
    );
  }

  saveRemoveCustTankList$(id: number, custIds: number[]): Observable<number[] | null> {
    return this._httpClient.post<number[]>(this.TANK_REMOVE_CUST_LIST_URL, { TankId: id, CustomerIds: custIds }).pipe(
      tap(response => {

      }),
      catchError(error => {
        console.log(error);
        return of(null);
      }),
    );
  }



}

